import React from 'react';
import { useTranslation } from 'react-i18next';

const BankDetailsInfo = ({
    title,
    accountName,
    accountNumber,
    sortCode,
    className = '',
    minimized = false
}: {
    title?: string;
    accountName: string;
    accountNumber: string;
    sortCode: string;
    className?: string;
    minimized?: boolean;
}) => {
    const { t } = useTranslation();

    const formattedSortCode = `**-**${sortCode?.slice(-2) ?? ''}`;
    const formattedAccountNumber = `*****${accountNumber?.slice(-4) ?? ''}`;

    if (minimized) {
        return (
            <div className={className}>
                {title && <h6 style={{ fontWeight: 800 }}>{title}</h6>}
                <div>
                    <b>{t('account_holder_name') + ': '}</b>
                    <span>{accountName}</span>
                </div>
                <div>
                    <b>{t('sort_code') + ': '} </b>
                    <span>{formattedSortCode}</span>
                </div>
                <div>
                    <b>{t('account_number') + ': '}</b>
                    <span>{formattedAccountNumber}</span>
                </div>
            </div>
        );
    }
    return (
        <div className={className}>
            {title && <h6 style={{ fontWeight: 800 }}>{title}</h6>}
            <div className='row mb-1 border-bottom'>
                <div className='col-6 fw-bold'>{t('account_holder_name')}</div>
                <div className='col-6 text-end'>{accountName}</div>
            </div>

            <div className='row mb-1 border-bottom'>
                <div className='col-6 fw-bold '>{t('sort_code')}</div>
                <div className='col-6 text-end'>{formattedSortCode}</div>
            </div>

            <div className='row border-bottom'>
                <div className='col-6 fw-bold'>{t('account_number')}</div>
                <div className='col-6 text-end'>{formattedAccountNumber}</div>
            </div>
        </div>
    );
};

export default BankDetailsInfo;
